module.exports = __webpack_public_path__ + "img/germany.ad173c92.png";